import { ProductListVariantsModel } from 'autogen/swagger/all';
import { SwatchSize } from 'components/product/Variants/Swatches/shared/types';
import MoreVariants from './MoreVariants';
import VariantName from './VariantName';

export default function VariantRenderer({
    variants,
    size,
    ...restProps
}: {
    variants: ProductListVariantsModel;
    size?: SwatchSize;
}) {
    const { totalAmount } = variants;

    return totalAmount > 1 ? (
        <MoreVariants variants={variants} size={size} {...restProps} />
    ) : (
        <VariantName variants={variants} {...restProps} />
    );
}
